import React from 'react';
import logo from '../logo.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <div className="brand">
            <img src={logo} alt="Global Sun Energy Solution" className="brand-logo" />
            <span className="brand-name">
              <strong>Global Sun</strong>
              <em>Energy Solution</em>
            </span>
          </div>
          <p>
            Engineering India's transition to clean, reliable solar power —
            one roof, one grid, one state at a time.
          </p>
          <div className="footer-socials">
            {['in', 'X', 'fb', 'ig'].map((s) => (
              <a key={s} href="#top" aria-label={s}>{s}</a>
            ))}
          </div>
        </div>

        <div className="footer-cols">
          <div>
            <h4>Products</h4>
            <ul>
              <li><a href="#products">Helios Panels</a></li>
              <li><a href="#products">Pulse Inverters</a></li>
              <li><a href="#products">Helios Storage</a></li>
              <li><a href="#products">Sol Charge</a></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#process">Process</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4>Resources</h4>
            <ul>
              <li><a href="#contact">Datasheets</a></li>
              <li><a href="#contact">Warranty</a></li>
              <li><a href="#contact">Press</a></li>
              <li><a href="#contact">Careers</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container footer-bottom">
        <span>© {new Date().getFullYear()} Global Sun Energy Solution. All rights reserved.</span>
        <span>Built with sunlight ☀</span>
      </div>
    </footer>
  );
}
